<div class="renal-values">
  <div class="renal-values__container">
    <div class="renal-values__date">
      <app-icon class="renal-values__date__icon" [name]="IconName.calendar"></app-icon>
      {{ consultation.date | date: 'shortDate' }}
    </div>
    <div class="renal-values__values">
      <span>{{ creatinine | uppercase }}</span>
      <span class="renal-values__value"
        >{{ consultation?.prediction?.creatinine?.value }} {{ consultation?.prediction?.creatinine?.unit }}</span
      >

      <span>{{ urea | uppercase }}</span>
      <span class="renal-values__value">{{ consultation?.prediction?.urea?.value }} {{ consultation?.prediction?.urea?.unit }}</span>

      <span>{{ urine | uppercase }}</span>
      <span class="renal-values__value">{{ consultation?.prediction?.urine?.value }}</span>
    </div>
  </div>
</div>
